export const TABLET = 1300;
export const MOBILE_THRESHOLD = 1024;
export const TABLET_SMALL = 900;
export const MOBILE_SMALL = 600;

export const SIDEBAR_THRESHOLD = 1368;
